import { FaFilePdf, FaFileExcel } from "react-icons/fa";

export default {
  REG_EXPR_VALID_PAN: /^\d{6}(\*{6,9}|\d{6,9})\d{4}$/,
  //REG_EXPR_VALID_PAN : /^\d{6}(\*{6}|\*{9}|\d{6}|d{9})\d{4}$/ ,
  //REG_EXPR_VALID_MASKED_PAN : /^\d{6}(\*{6}|\*{9})\d{4}$/,
  REG_EXPR_VALID_DIGITS: /^\d+$/,
  REG_EXPR_VALID_AMOUNT: /^\d{1,10}(\.\d{2,3})?$/,

  TXN_IDENTIFIER_CUSTOM: { name: "custom", label: "Identifier." },
  TXN_IDENTIFIER_PAN: { name: "pan", label: "PAN" },
  TXN_IDENTIFIER_PAYCODE: { name: "paycode", label: "Paycode" },
  TXN_IDENTIFIER_CUSTOMERREF: {
    name: "customerReference",
    label: "Customer Reference"
  },
  TXN_IDENTIFIER_MOBILE_NO: { name: "mobileNo", label: "Mobile No." },

  MAX_DATE_RANGE_DAYS: 0,
  DATE_FORMAT: "YYYY-MM-DD",
  DATE_FORMAT_LONG: "YYYY-MM-DD HH:mm:ss",
  DEFAULT_TABLE_PAGE_SIZE: 10,

  ROUTES_BASE_CONTEXT_PATH: "/portal/arbiter/app", //TODO Routes should not be dependent on this context path when deployed on ISW Portal



  DISPUTE_CATEGORY_CHARGEBACK: "CHARGEBACK",
  DISPUTE_CATEGORY_REFUND: "REFUND",
  DISPUTE_CATEGORY_FRAUD: "FRAUD",
  DISPUTE_CATEGORY_MERCHANT_SETTLEMENT: "MERCHANT_SETTLEMENT",
  DISPUTE_CATEGORY_GOOD_FAITH: "GOOD_FAITH",

  DISPUTE_ACTION_ACCEPT: "Accept",
  DISPUTE_ACTION_COMMENT: "Comment",
  DISPUTE_ACTION_DECLINE: "Decline",
  DISPUTE_ACTION_REOPEN: "Reopen",

  DISPUTE_FIELD_EVIDENCE: "evidence",
  DISPUTE_FIELD_COMMENT: "comment",

  STATUS_ACTION_REQUIRED_PROPS: "required",
  ERROR_LIST_RESPONSE_PROPS: "errors",

  TRANSACTIONS_DISPUTE_AMOUNT_PARTIAL: "Partial",
  TRANSACTIONS_DISPUTE_AMOUNT_FULL: "Full",

  EVIDENCE_FILE_FORMATS: "Image [JPEG|PNG]",
  MAXIMUM_EVIDENCE_FILE_SIZE: 204800, //~200KB
  MAXIMUM_EVIDENCE_UPLOAD_COUNT: 5,

  BATCH_FILE_FORMATS: "Microsoft Excel [XLS|XLSX]",
  MAXIMUM_BATCH_FILE_SIZE: 512000, //~500KB
  MAXIMUM_BATCH_RECORD_COUNT: 1000,

  COOKIE_PREFIX_NEVER_ASK: "NEVER_ASK_",

  BATCH_STATUS_COMPLETED: "Completed",

  SETTLEMENT_REQUEST_ACTION_MAP: "MAP",
  SETTLEMENT_REQUEST_ACTION_PROCESS: "PROCESS",
  SETTLEMENT_REQUEST_ACTION_CANCEL: "CANCEL",

  SETTLEMENT_REQUEST_STATUS_MAPPING: "MAPPING",
  SETTLEMENT_REQUEST_STATUS_PENDING: "PENDING",
  PAGINATION_OFFSET_INDEX: 1,

  PERIOD_TYPES_BUSINESSDAY: "Business Day",
  PERIOD_TYPES_CALENDARDAY: "Calendar Day",

  BREADCRUMB_SEPARATOR: " / ",

  SETTLEMENT_TYPES: [
    { label: "Resettlement", value: "Resettlement" },
    { label: "Reversal", value: "Reversal" },
    { label: "Arbitration Reversal", value: "Arbitration_Reversal" }
  ],

  REPORT_TYPES: [
    { label: "Disputes", value: "dispute" },
    { label: "Settlements", value: "settlement" }
  ],

  get PERIOD_TYPES() {
    return [
      {
        label: this.PERIOD_TYPES_BUSINESSDAY,
        value: this.PERIOD_TYPES_BUSINESSDAY
      },
      {
        label: this.PERIOD_TYPES_CALENDARDAY,
        value: this.PERIOD_TYPES_CALENDARDAY
      }
    ];
  },

  SETTLEMENT_REPORT_MAXTIME: 300000,

  SETTLEMENT_REPORT_STATUS: {
    COMPLETED: "completed",
    PROCESSING: "processing",
    PENDING: "pending",
    FAILED: "failed"
  },

  REPORT_STATUS: [
    {
      label: "Completed",
      value: "completed"
    },
    {
      label: "Processing",
      value: "processing"
    },
    {
      label: "Pending",
      value: "pending"
    },
    {
      label: "Failed",
      value: "failed"
    }
  ],

  SETTLEMENT_REPORT_TYPES: [
    {
      name: "PDF",
      value: "pdf",
      icon: FaFilePdf,
      color: "#BB0706"
    },
    {
      name: "Excel",
      value: "excel",
      icon: FaFileExcel,
      color: "#1F6F43"
    }
  ]
};



// WEBPACK FOOTER //
// ./src/configurations/constants.js